import { render, staticRenderFns } from "./ActiviteitDeleteDialog.vue?vue&type=template&id=0ff4ec1c"
import script from "./ActiviteitDeleteDialog.vue?vue&type=script&lang=ts"
export * from "./ActiviteitDeleteDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports